import { ArrowUpRight } from "lucide-react";
import { SOCIALS, DISCLAIMER } from "../../data/content";

export const Footer = () => {
  const go = (href) => {
    const el = document.querySelector(href);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -10 });
    else el.scrollIntoView({ behavior: "smooth" });
  };
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-ink border-t border-white/10 pt-20 pb-10" data-testid="footer">
      <div className="container-editorial">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-6">
            <button onClick={() => go("#hero")} className="font-serif text-3xl tracking-tight text-bone text-left">
              Dakka<span className="text-gold"> Gabriel Rey</span>
            </button>
            <p className="mt-4 text-ash max-w-sm leading-relaxed">
              Trading, Knowledge and Life Transformation — at the intersection of markets,
              discipline, and meaningful growth.
            </p>
            <button onClick={() => go("#contact")} className="btn-ghost mt-8">
              Follow the Journey <ArrowUpRight size={16} />
            </button>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Explore</p>
            <ul className="space-y-3">
              {["About", "Journey", "Trading", "Values", "Insights", "Contact"].map((l) => (
                <li key={l}>
                  <button
                    onClick={() => go(`#${l.toLowerCase()}`)}
                    className="text-ash hover:text-gold transition-colors"
                  >
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Connect</p>
            <ul className="space-y-3">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="inline-flex items-center gap-1.5 text-ash hover:text-gold transition-colors"
                  >
                    {s.label} <ArrowUpRight size={13} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* disclaimer */}
        <div className="py-10 border-b border-white/10">
          <p className="overline mb-3 text-ash">Disclaimer</p>
          <p className="text-sm text-ash/80 leading-relaxed max-w-4xl">{DISCLAIMER}</p>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-mono text-xs text-ash">© {year} Dakka Gabriel Rey. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="font-mono text-xs text-ash hover:text-gold transition-colors">Privacy Policy</a>
            <a href="#" className="font-mono text-xs text-ash hover:text-gold transition-colors">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
